import { Link } from "@tanstack/react-router";
import { WhatAppIcon } from "./WhatAppIcon";

type Variant = "navy" | "white" | "teal" | "lavender";

const colorMap: Record<Variant, string> = {
  navy: "text-black",
  white: "text-white",
  teal: "text-teal",
  lavender: "text-lavender",
};

export function Logo({
  variant = "navy",
  className = "",
}: {
  variant?: Variant;
  showTagline?: boolean;
  className?: string;
}) {
  return (
    <Link to="/" aria-label="what — home" className={`inline-block ${colorMap[variant]} ${className}`}>
      <WhatAppIcon className="h-10 sm:h-12 w-auto" aria-hidden />
    </Link>
  );
}
